import http from './api'

const url = '/reports'

export const httpCreateReport = (data) => {
  console.log("httpCreateReport called with data:", data);
  return http({
    url: `${url}/create_and_generate/`,
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

export const httpGetReports = (params) => {
  console.log("httpGetReports called with params:", params);
  return http({
    url: `${url}/`,
    method: 'GET',
    params,
  })
}

export const httpGetReport = (id) => {
  console.log("httpGetReport called with id:", id);
  return http({
    url: `${url}/${id}/`,
    method: 'GET',
  })
}

export const httpGenerateExport = (id) => {
  console.log("httpGenerateExport called with id:", id);
  return http({
    url: `${url}/${id}/generate_export/`,
    method: 'POST',
    responseType: 'blob',
  })
}

export const httpDownloadFile = (id) => {
  console.log("httpDownloadFile called with id:", id);
  return http({
    url: `${url}/${id}/download_file/`,
    method: 'GET',
    responseType: 'blob',
  })
} 